import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_PETITION_AI_SUMMARIES_COMBO_EXPERIMENT = createFcmDetails(
	'revenue_petition_ai_summaries_combo_experiment',
	{
		owner: 'Revenue/Koi Squad',
		context: 'PSF Combo Page',
		description: 'Displays AI summary title for revenue petitions on the combo page.',
		import: false,
		template: {
			experiment_name: 'exp_v1',
			enabled: false,
		},
	},
);
